// config/env.js
// Environment configuration
// Toggle ENV to 'prod' before deploying

export const ENV = 'dev'; // 'dev' or 'prod'

export const IS_DEV = ENV === 'dev';
export const IS_PROD = ENV === 'prod';

export default {
    ENV,
    IS_DEV,
    IS_PROD,
};
